import { useRef, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import InvoiceSimpleGenerator from '../components/Invoice/InvoiceSimpleGenerator';
import { t } from '../i18n';

const apiUrl = process.env.REACT_APP_API_URL;

export default function InvoiceSimpleAddPage() {
  const { id: invoiceId } = useParams();
  const invoiceGeneratorRef = useRef();

  // State for existing invoice data (for edit mode)
  const [existingInvoiceData, setExistingInvoiceData] = useState(null);

  // Fetch existing invoice data for edit mode
  useEffect(() => {
    const fetchExistingInvoiceData = async () => {
      if (!invoiceId) return;

      try {
        const token = localStorage.getItem('token');
        if (!token) return;

        const response = await fetch(`${apiUrl}/simple-invoice-view/${invoiceId}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          setExistingInvoiceData(data);
        }
      } catch (error) {
        console.error('Failed to fetch existing invoice data:', error);
      }
    };

    fetchExistingInvoiceData();
  }, [invoiceId]);

  const handleSave = () => {
    if (invoiceGeneratorRef.current) {
      invoiceGeneratorRef.current.handleSave();
    }
  };

  const handleSaveDraft = () => {
    if (invoiceGeneratorRef.current) {
      invoiceGeneratorRef.current.handleSaveDraft();
    }
  };

  const breadcrumbPaths = invoiceId
    ? [
        { label: t('Финансии'), to: '/invoices' },
        { label: t('Едноставни фактури'), to: '/simple-invoice/add' },
        { label: existingInvoiceData?.invoice?.invoice_number ? t('Уреди фактура #{number}', { number: existingInvoiceData.invoice.invoice_number }) : t('Уреди фактура'), className: 'text-orange-600 font-semibold' }
      ]
    : [
        { label: t('Финансии'), to: '/invoices' },
        { label: t('Едноставни фактури'), to: '/simple-invoice/add' },
        { label: t('Нова фактура'), className: 'text-green-600 font-semibold' }
      ];

  return (
    <div className="min-h-screen bg-gray-100 -m-8 p-8">
      <div className="flex gap-6">
        <InvoiceSimpleGenerator
          ref={invoiceGeneratorRef}
          existingInvoiceData={existingInvoiceData}
          isEdit={!!invoiceId}
        />
        <div className="w-48 p-4 bg-white border border-gray-200 rounded-lg shadow-sm flex flex-col gap-3 h-fit">
          <button onClick={handleSave} className="w-full bg-orange-600 text-white py-2 px-4 rounded hover:bg-orange-700 text-sm font-medium">
            {t('Зачувај')}
          </button>
          <button onClick={handleSaveDraft} className="w-full bg-yellow-100 text-yellow-900 py-2 px-4 rounded hover:bg-yellow-200 text-sm font-medium">
            {t('Зачувај нацрт')}
          </button>
        </div>
      </div>
    </div>
  );
}
